import Echo from 'laravel-echo/dist/echo'
import Pusher from 'pusher-js'
import store from '@cc/store'

const pusherKey = store.state.config.pusher.key
const pusherCluster = store.state.config.pusher.cluster

const setupEcho = () => {
  return new Echo({
    broadcaster: 'pusher',
    namespace: 'Expreso.Business.Events',
    client: new Pusher(pusherKey, {
      cluster: pusherCluster,
      forceTLS: true
    })
  })
}

export {
  setupEcho
}
